module.exports = __webpack_public_path__ + "static/img/btn-bg.da1358cb.png";